module.exports = __webpack_public_path__ + "static/media/action-arrow.54e385a9.svg";